export default __webpack_public_path__ + "static/media/AcademyIcon.36e588d1.png";